// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","map":"map-wrapper_map__mEC3W","mapContainer":"map-wrapper_mapContainer__ItT4v"};